import { render } from "./locale-button.vue?vue&type=template&id=1647de63&scoped=true"
import script from "./locale-button.vue?vue&type=script&lang=js"
export * from "./locale-button.vue?vue&type=script&lang=js"

import "./locale-button.vue?vue&type=style&index=0&id=1647de63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1647de63"]])

export default __exports__